import { render, staticRenderFns } from "./zhaopinxinxi0.vue?vue&type=template&id=51ecdf4c&scoped=true&"
import script from "./zhaopinxinxi0.vue?vue&type=script&lang=js&"
export * from "./zhaopinxinxi0.vue?vue&type=script&lang=js&"
import style0 from "./zhaopinxinxi0.vue?vue&type=style&index=0&id=51ecdf4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ecdf4c",
  null
  
)

export default component.exports